import { joiResolver } from '@hookform/resolvers/joi';
import { DefaultValues, useForm, UseFormReturn } from 'react-hook-form';
import { FormUpdateApplication } from '../../../models';
import applicationStatusSchema from '../schema/applicationStatusSchema';

interface FormUpdateApplicationReturn {
  /**
   * Perform submit action, either to call block call or unblock call, depends on the account status
   */
  submitForm: (submitData: FormUpdateApplication) => void;
  /**
   * Form to send edit & delete
   */
  formHook: UseFormReturn<FormUpdateApplication>;
  /**
   * React query mutation object
   */
}

/**
 * A hook to handle search functionality
 * @returns
 */

interface UseUpdateApplicationProps {
  formDefaultValues: DefaultValues<FormUpdateApplication>;
}

export const useUpdateApplication = ({
  formDefaultValues,
}: UseUpdateApplicationProps): FormUpdateApplicationReturn => {
  const formHook = useForm<FormUpdateApplication>({
    mode: 'onSubmit',
    resolver: joiResolver(applicationStatusSchema),
    defaultValues: formDefaultValues,
  });

  const submitForm = (submitData: FormUpdateApplication) => {
    // do nothing
  };

  return {
    formHook,
    submitForm,
  };
};
